import React from "react";
import styled from "styled-components";
import {Page} from "../../components/styled"
import { useState } from "react";
import HunterPackIncludesImage from "../../assets/images/hunterPackIncludesImage.png"
import HunterPackImage from "../../assets/images/hunterPackImage.png"
import PromoPackImage from "../../assets/images/promopack.png"
import { useLocation } from "react-router-dom";
import SplashLogoImage from "../../assets/images/logo/splashlogo.png";
import OpenPachHandImage from "../../assets/images/openpackhand.png";
import { blink } from "../../components/styled/animations";
import { rollOutLeft } from "../../components/styled/animations";
import { useNavigate } from "react-router-dom";
import { prosessInventoryItemUse } from "../../service/main/api";
import { useLoading } from "../../context/LoadingContext";
import OpenPackageAnimation from '../../assets/animations/openPackage.json';
import Lottie from "lottie-react";

const generateTornPathPoints = (width, startY = 61, tearHeight = 10, jaggedness = 15) => {
    let points = [`M0,${startY + tearHeight}`];
    const step = width / 20;

    for (let x = step; x <= width; x += step) {
        const y = startY + tearHeight + (Math.random() * jaggedness - jaggedness / 2);
        points.push(`L${x},${y}`);
    }

    points.push(`L${width},${startY}`, `L0,${startY}`, "Z"); // Path’i kapat
    return points;
};
const OpenPack = () => {
    const lottieRef = React.useRef();
    const cards = React.useRef();
    const { setCryptidLoading } = useLoading();
    // const [step, setStep] = useState(2) // 1 -2
    const [tearPath, setTearPath] = useState("M0,51")
    const [isOpened, setIsOpened] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();
    const {state} = location;
    const {item} = state;
    if(!item) return
    const handleUseItem = async () => {
      setCryptidLoading(true);
       const res =  await prosessInventoryItemUse(item._id);
       setIsOpened(true);
       if(res?.success){
            console.log(res.data);
            cards.current = res.data;
          setTimeout(() => {
            lottieRef.current.play();
            // handleOpenAnimation(res.data);
            setCryptidLoading(false);
           }
           , 1000);
       }else{
        setCryptidLoading(false);
              alert(res.message);
       }       
    }
    const handleOpenAnimation = (cards) => {
        let normalizedCards = [];
        cards.map((card) => {
            let cardData = {
                _id: card._id,
                name: card.name,
                rarity: card.rarity,
                level: card.level,
                type: card.cryptidType,
                weakness: card.weaknessType,
                miningPower: card.baseMiningPower || card.rarity.miningPerDay,
                imageUri: card.imageUri || null,
            }
            normalizedCards.push(cardData);
        });
        const fullPath = generateTornPathPoints(393); // Tüm yırtık path'ini oluştur
        let index = 1;
        const interval = setInterval(() => {
            if (index < fullPath.length && fullPath[index] !== "Z") {
                setTearPath((prev) =>`${prev} ${fullPath[index]}`); // Yeni noktayı ekleyerek güncelle
                index++;
            } else {
                clearInterval(interval); // Animasyonu bitir
            }
        }, 20); 
        setTimeout(() => {
            navigate("/previewPack", { state: { cards: normalizedCards } });
        },
        1000);
        return () => clearInterval(interval);
       
    };

    return(
        <Page>
             {/* <Blured step={step} onClick={() => setStep(2)}>
                <img src={HunterPackIncludesImage} alt="hunter pack includes" />
            </Blured> */}
            <HunterPackContainer>
                <div style={{position:"relative",display:"flex", justifyContent:"center"}}>
                <Lottie
                onComplete={()=> {
handleOpenAnimation(cards.current);
                }}
                    lottieRef={lottieRef}
                    style={{ width: 480 }}
                    loop={false}
                    autoplay={false}
                    animationData={OpenPackageAnimation}
                />
                {!isOpened && 
                <OpenPackHand onClick={handleUseItem} src={OpenPachHandImage} alt="open pack hand" />}
                </div>
                {/* <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 393 438">
                <defs>
                        <mask id="tearMask">
                            <rect width="100%" height="100%" fill="white" />
                            <path d={tearPath} fill="black"></path>
                        </mask>
                    </defs>
                    
                <image mask={"url(#tearMask)"} width="100%" height="100%" xlinkHref={item.item.name === "Hunter Pack" ? HunterPackImage : PromoPackImage}/>
                </svg> */}
                {/* {!isOpened && 
                <OpenPackHand onClick={handleUseItem} src={OpenPachHandImage} alt="open pack hand" />} */}
                {/* {item.item.name === "Hunter Pack" && <SplashLogo src={SplashLogoImage} alt="splash logo" />} */}
            </HunterPackContainer>
        </Page>
    )

};
const Blured = styled.div`
    position: fixed;
    width: 100%;
    height: 100%;
    background: #00000033;
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    z-index: 3;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 0;
    left: 0;
    animation:${props => props.step !== 1  ? rollOutLeft : ""} 0.65s cubic-bezier(0.755, 0.050, 0.855, 0.060) both;
    img{
        margin-top: 10%;
    }

`
const HunterPackContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
    width: 100%;
    height: 70%;
    position:absolute;
    bottom: 0;
    max-width: 420px;
    padding-bottom: calc(77px + var(--tg-safe-area-inset-bottom, 0px));
`;

const SplashLogo = styled.img`
    width: 100%;
    max-width:320px;
    margin-top: 20px;
    position: absolute;
    z-index: 2;
`
const OpenPackHand = styled.img`
    position: absolute;
    top: 200px;
    width: 160px;
    margin-right: -30px;
    z-index: 2;
    animation: ${blink} 1s infinite;
`
export default OpenPack;